import Swal from "sweetalert2";
export const handleTransferDelete = async (transferId, {fetchData, setDeletingTransferId, cars, rentals, coupons, contact, drivers, tours, tourBookings, employeeService, setCarsData, setRentalsData, setCouponsData, setTransfersData, setDriversData, setToursData, setTourBookingsData, setEmployeesData, setSeasonalPricing, setIsLoading, setError}) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to recover this transfer record!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#1e3a8a",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        setDeletingTransferId(transferId);
        await contact.deleteTransfer(transferId);
        await Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "The transfer record has been deleted.",
          confirmButtonColor: "#1e3a8a",
        });
        fetchData();
      }
    } catch (error) {
      console.error("Error deleting transfer:", error);
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to delete transfer. Please try again.",
        confirmButtonColor: "#1e3a8a",
      });
    } finally {
      setDeletingTransferId(null);
    }
  };